import Button from 'carbon-react/esm/components/button/__next__';
import { useLocalStorage } from 'usehooks-ts';
import { ContentErrorFallback } from '../../../components/ErrorFallback/ContentErrorFallback';
import type { ErrorFallbackProps } from '../../../components/ErrorFallback/ErrorFallbackBase';
import { DSN_SORT_STORAGE_KEY, INITIAL_DSN_SORT, type DsnSortState } from '../dsnTableSorting';
import { useDsnListLocalStorage } from '../../../hooks/useDsnListLocalStorage';

export function DsnListErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const [, setSort] = useLocalStorage<DsnSortState>(DSN_SORT_STORAGE_KEY, INITIAL_DSN_SORT);
  const { resetFilters } = useDsnListLocalStorage();

  const retryWithDefaultSort = () => {
    setSort(INITIAL_DSN_SORT);
    resetErrorBoundary();
  };

  const retryWithDefaultFilters = () => {
    resetFilters();
    resetErrorBoundary();
  };

  return (
    <ContentErrorFallback
      error={error}
      resetErrorBoundary={resetErrorBoundary}
      additionalActions={
        <>
          <Button onClick={retryWithDefaultSort} variantType="secondary" size="large">
            Tri par défaut
          </Button>
          <Button onClick={retryWithDefaultFilters} variantType="secondary" size="large">
            Filtres par défaut
          </Button>
        </>
      }
    />
  );
}
